import { reducer } from './reducer';
import { REDUCER_NAME } from './constants';
export { reducer, REDUCER_NAME };
export { setTheme } from './actions';
export const themeReducerObject = { [REDUCER_NAME]: reducer };
